<template lang="pug">
  .notice-block(:class="type")
    .header
      a.text {{title}}
    .content
      p.info(v-if="info" v-html="info")
      .json-data(v-if="body")
        p.callout If you need to report this error, please include the response output below
        pre
          p.json-comment // Request time: {{ new Date().toISOString() }}
          p.json-body {{ JSON.stringify(body, null, 2) }}
      a.link(v-if="link", @click="$emit('go-to')") {{link}}
    .close(v-if="action === 'refresh'" v-on:click="refreshPage")
      lei-popover(:text="tooltips.newsbarRefresh")
        button.refresh-button(v-on:click="refreshPage")
          img(src="/static/icons/refresh-icon.svg")
    .close(v-if="action === 'close'")
      lei-popover(:text="tooltips.newsbarClose")
        a.times(@click="$emit('close')") &times;
</template>

<script>
import { mapMutations, } from 'vuex'
import { CLOSE_NEW_LINE, } from '../../store/mutations-types'
import LeiPopover from '../lei-components/LeiPopover'
import simple from '../../constants/tooltips/simple'

export default {
  components: {
    LeiPopover,
  },
  props: {
    type: {
      type: String,
      default: 'info',
    },
    title: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    info: {
      type: String,
      default: null,
    },
    body: {
      type: [ Object, String, ],
      default: null,
    },
    action: {
      type: String,
      default: 'close',
    },
  },
  data () {
    return {
      tooltips: simple,
    }
  },
  methods: {
    refreshPage () {
      document.location.reload(true)
    },
    ...mapMutations({
      close: CLOSE_NEW_LINE,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .notice-block
    display flex
    flex-direction column
    border-radius 4px
    width 100%
    background-color #FFF8F7
    border-left 4px solid #D92D20
    padding 16px

    .header
      display flex
      align-items center
      margin-bottom 12px
      background-color transparent
      padding 0

      .text
        color #D92D20
        font-weight 600
        font-size 16px
        text-transform none

    .content
      width 100%
      padding 0
      display flex
      flex-direction column
      border none
      font-size 14px

      .info
        color #344054
        font-weight 400
        margin-bottom 16px

    .json-data
      width 100%

      p.callout
        font-size 12px
        color #667085
        font-weight 400
        margin-bottom 10px
        font-style italic

      pre
        padding 12px
        margin 0
        overflow auto
        background #FFFFFF
        border 1px solid #E4E7EC
        border-radius 4px
        font-family monospace
        font-size 12px
        text-align left
        white-space pre-wrap
        word-break break-all
        font-weight 400
        color #344054

      .json-comment
        font-size 12px
        color #667085
        font-style italic
        font-weight 400
        margin-bottom 4px

      .json-body
        margin-top 8px

    .close
      position absolute
      right 16px
      top 16px

      .refresh-button
        border none
        cursor pointer
        background none
        display flex
        align-items center
        justify-content center

        img
          height 16px
          fill #667085
          color #667085

    &.warning
      .header
        color #D92D20
        background-color transparent

  @media (max-width: $laptop)
    .notice-block
      padding 16px
      position relative
      border-radius 4px
      background-color #FFF8F7
      border-left 4px solid #D92D20
      font-size 14px

      .header
        margin-bottom 12px
        padding 0

        .text
          color #D92D20
          font-weight 600
          font-size 16px

      .content
        .info
          color #344054
          font-weight 400
          width 100%
          margin-bottom 16px

        .json-data
          width 100%

          p.callout
            font-size 12px
            color #667085
            font-weight 400
            margin-bottom 10px
            font-style italic

          pre
            padding 12px
            margin 0
            overflow auto
            background #FFFFFF
            border 1px solid #E4E7EC
            border-radius 4px
            font-family monospace
            font-size 12px
            text-align left
            white-space pre-wrap
            word-break break-all
            font-weight 400
            color #344054

          .json-comment
            font-size 12px
            color #667085
            font-style italic
            font-weight 400
            margin-bottom 4px

          .json-body
            margin-top 8px

      .close
        position absolute
        right 16px
        top 16px
        border none

        .refresh-button
          img
            height 16px
            fill #667085
            color #667085

      &.warning
        border-color #D92D20
        .header
          color #D92D20
          background-color transparent
</style>



// WEBPACK FOOTER //
// src/components/lei-components/NoticeBlock.vue